exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".anchor_box_978601c{display:flex;position:fixed;top:88px;right:40px;z-index:1001;width:95px;flex-direction:column}.anchor_box_978601c .anchor_item_d33a1ce{display:block;width:100%;line-height:32px;text-align:center;color:#188fff;font-weight:700;margin:8px 0;border-radius:16px;background:#fff;transition:all .3s linear}.anchor_box_978601c .anchor_item_d33a1ce.anchor_active_b9c82c6{background:#178fff;color:#fff;transition:all .3s linear}", ""]);

// exports
exports.locals = {
	"anchor_box": "anchor_box_978601c",
	"anchor_item": "anchor_item_d33a1ce",
	"anchor_active": "anchor_active_b9c82c6"
};